/**
 * 多言語テキスト取得ユーティリティ
 * 130問マルチフォーマット質問システム用
 * スケールラベル定数（10言語対応）
 */
import type { SupportedLanguage } from '../types/questionnaire';

/**
 * 5段階スケールラベル（10言語対応）
 * index 0 = 1点, index 4 = 5点
 */
export const SCALE_LABELS: Record<SupportedLanguage, [string, string, string, string, string]> = {
  ja: ['全く当てはまらない', 'あまり当てはまらない', 'どちらでもない', 'やや当てはまる', 'とても当てはまる'],
  en: ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'],
  id: ['Sangat Tidak Setuju', 'Tidak Setuju', 'Netral', 'Setuju', 'Sangat Setuju'],
  mn: ['Огт зөвшөөрөхгүй', 'Зөвшөөрөхгүй', 'Дундаж', 'Зөвшөөрөх', 'Маш их зөвшөөрөх'],
  ne: ['कत्ति पनि सहमत छैन', 'सहमत छैन', 'तटस्थ', 'सहमत', 'धेरै सहमत'],
  vi: ['Hoàn toàn không đồng ý', 'Không đồng ý', 'Trung lập', 'Đồng ý', 'Hoàn toàn đồng ý'],
  ar: ['لا أوافق بشدة', 'لا أوافق', 'محايد', 'أوافق', 'أوافق بشدة'],
  bn: ['একদম একমত নই', 'একমত নই', 'নিরপেক্ষ', 'একমত', 'সম্পূর্ণ একমত'],
  zh: ['完全不同意', '不同意', '中立', '同意', '完全同意'],
  es: ['Totalmente en desacuerdo', 'En desacuerdo', 'Neutral', 'De acuerdo', 'Totalmente de acuerdo'],
};

/**
 * スケールラベルを取得（フォールバック: 日本語）
 */
export function getScaleLabel(language: SupportedLanguage, value: number): string {
  const labels = SCALE_LABELS[language] ?? SCALE_LABELS.ja;
  const index = Math.max(0, Math.min(4, value - 1));
  return labels[index];
}
